<template>
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 12.2501L9.63313 9.62858M11.0833 6.12508C11.0833 7.44011 10.5609 8.70128 9.63103 9.63115C8.70116 10.561 7.43999 11.0834 6.12496 11.0834C4.80993 11.0834 3.54876 10.561 2.61889 9.63115C1.68902 8.70128 1.16663 7.44011 1.16663 6.12508C1.16663 4.81005 1.68902 3.54888 2.61889 2.61901C3.54876 1.68914 4.80993 1.16675 6.12496 1.16675C7.43999 1.16675 8.70116 1.68914 9.63103 2.61901C10.5609 3.54888 11.0833 4.81005 11.0833 6.12508V6.12508Z"
      stroke="currentColor"
      stroke-width="1.16667"
      stroke-linecap="round"
    />
  </svg>
</template>
